import React from "react";
import { StyleSheet, Text } from "react-native";

const DeliveryOrderCount = ({ data }) => {
  return <Text style={styles.text}>{data?.items_count}</Text>;
};

const styles = StyleSheet.create({
  text: {
    fontSize: 16,
    lineHeight: 24,
    fontFamily: "NotoSansDevanagari-Bold",
    marginRight: 6,
  },
});

export default DeliveryOrderCount;
